import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/translations';

export const useTranslation = () => {
  const { language } = useLanguage();

  /**
   * Translate a key into the current language
   * @param key The translation key to look up
   * @param params Optional parameters to replace in the translation string
   * @returns The translated string
   */
  const t = (key: string, params?: Record<string, string>): string => {
    // Get the translations for the current language
    const currentTranslations = translations[language] || translations.he;
    
    // Try to get the translation for the key
    let translatedText = currentTranslations[key] || key;
    
    // Replace any parameters in the translation
    if (params) {
      Object.entries(params).forEach(([paramKey, paramValue]) => {
        translatedText = translatedText.replace(
          new RegExp(`{{${paramKey}}}`, 'g'), 
          paramValue
        );
      });
    }
    
    return translatedText;
  };

  return { t };
}; 